module.exports = __webpack_public_path__ + "assets/img/aboutUS-module1-1.2a421cad.jpg";